<section class="navBarSection" id="navber">
      <nav class="navbar navbar-expand-lg">
        <div class="container-fluid">
          <div *ngIf="isLogin">
            <a href="/admin" class="d-flex align-items-center pt-3 pb-3 text-decoration-none nav-link">
              <span class="fs-5 d-none d-sm-inline text-uppercase fw-bold">{{'admin' | translate}}</span>
            </a>
          </div>
          <a [routerLink]="['/home']">
            <img
            class="logoImage white"
            src="assets/img/logo-stc-white.png"
            alt="STC Channels logo"
            />
            <img
            class="logoImage color"
            src="assets/img/channel-logo-color.webp"
            alt="STC Channels logo"
            />
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ps-5 mb-lg-0">
              <li class="nav-item">
                <a
                  class="nav-link"
                  [routerLink]="['/home']"
                  aria-current="page"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  routerLinkActive="active"
                  >{{ "home" | translate }}</a
                >
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  id="navbarDropdownMenuLink"
                  routerLinkActive="active"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ "about-us" | translate }}
                </a>
                <ul
                  class="dropdown-menu allDropDown"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <li>
                    <a
                      class="dropdown-item BoardOfDirectors"
                      [routerLink]="['/board-of-directors']"
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarSupportedContent"
                      routerLinkActive="active"
                      ><span class="navDrop-item">{{
                        "board-management" | translate
                      }}</span></a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      [routerLink]="['/sales-channels']"
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarSupportedContent"
                      routerLinkActive="active"
                      ><span class="navDrop-item">{{
                        "sales-channels" | translate
                      }}</span></a
                    >
                  </li>
                </ul>
              </li>
              <li class="nav-item" routerLinkActive="active">
                <a
                  class="nav-link"
                  [routerLink]="['/products-and-services']"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  routerLinkActive="active"
                >
                  {{ "ProductsAndServices" | translate }}</a
                >
              </li>
              <li class="nav-item" routerLinkActive="active">
                <a
                  class="nav-link"
                  [routerLink]="['/success-stories']"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  routerLinkActive="active"
                >
                  {{ "success-stories" | translate }}</a
                >
              </li>
              <li class="nav-item" routerLinkActive="active">
                <a
                  class="nav-link"
                  [routerLink]="['/vendor-relations']"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  routerLinkActive="active"
                  >{{ "vendor-relations" | translate }}</a
                >
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  id="language"
                  role="button"
                  routerLinkActive="active"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ "language" | translate }}
                </a>
                <ul class="dropdown-menu allDropDown" aria-labelledby="language">
                  <li>
                    <button
                      class="dropdown-item"
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarSupportedContent"
                      (click)="changeLanguage()"
                      >{{ "lang-ar" | translate }}</button
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
  </section>
  